import { atom } from 'recoil';

export const coordsState = atom({
	key: 'coordsState',
	default: {
		longitude: null,
		latitude: null,
		userAllowed: null,
		isLocationDefined: false,
		locationConfirmed: false,
	},
});
